import type { ReactNode } from 'react';

export const symbol_hiking: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M420-379 351-65q-2 11-11 18t-20 7q-15 0-24.5-11.5T289-77l114-583q5-24 23-37t38-13q20 0 37.5 9t28.5 26l39 64q19 32 52.5 57t78.5 39v-55q0-8 6-14t14-6q8 0 14 6t6 14v510q0 8-6 14t-14 6q-8 0-14-6t-6-14v-394q-51-11-96-39t-80-69l-29 145 76 72q5 5 7 10.5t2 11.5v253q0 13-8.5 21.5T550-40q-13 0-21.5-8.5T520-70v-214l-100-95Zm-150-69-46-9q-12-2-18.5-12.5T201-492l30-157q5-29 31-44.5t57-9.5q12 2 19 13t5 23l-38 195q-2 12-12.5 19t-22.5 5Zm208.5-327.5Q457-797 457-827t21.5-51.5Q500-900 530-900t51.5 21.5Q603-857 603-827t-21.5 51.5Q560-754 530-754t-51.5-21.5Z"
		/>
	</svg>
);
